import type { ExportColumnId, ExportGroupBy } from './exportColumns';

export type ExportLayout = 'combined' | 'per-employee' | 'separate-files';

export interface ExportReportRow {
  date: string;
  status: string;
  reportType: string;
  hospital: string;
  employee: string;
  employmentRole: string;
  quantity: number;
  ratePerUnit: number;
  hospitalBonus: number;
  amount: number;
  notes: string;
}

export interface ExportAllowanceRow {
  name: string;
  amount: number;
  period: string;
}

export interface ExportSupervisionBonusRow {
  hospitalName: string;
  reportTypeCode: string;
  totalUnits: number;
  bonusPerUnit: number;
  amount: number;
}

export interface ExportEmployeeRow {
  employeeName: string;
  employmentRole: string;
  totalReports: number;
  totalQuantity: number;
  reportsAmount: number;
  allowancesAmount: number;
  supervisionBonusAmount: number;
  totalAmount: number;
  reports: ExportReportRow[];
  allowances: ExportAllowanceRow[];
  supervisionBonuses: ExportSupervisionBonusRow[];
}

export interface ExportPayload {
  title: string;
  month: string;
  generatedAt: string;
  currencySymbol: string;
  isRTL: boolean;
  language: string;
  filters: {
    status?: string;
    hospitalName?: string;
    roleName?: string;
  };
  columns?: ExportColumnId[];
  groupBy?: ExportGroupBy;
  aggregated?: boolean;
  rows: ExportEmployeeRow[];
  totals: {
    employeeCount: number;
    reportCount: number;
    quantity: number;
    totalAmount: number;
  };
}

/** Create a single-employee payload from a full payload */
export function slicePayloadForEmployee(
  payload: ExportPayload,
  row: ExportEmployeeRow,
): ExportPayload {
  return {
    ...payload,
    rows: [row],
    totals: {
      employeeCount: 1,
      reportCount: row.totalReports,
      quantity: row.totalQuantity,
      totalAmount: row.totalAmount,
    },
  };
}
